<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">提现列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <div class="withdraw_list">
      <div class="list_detail" v-for="(item,index) in withdrawList" :key="index" @click="detailtap(index)">
        <div class="list_top">
          <div class="list_time">{{item.created_at_str}}</div>
          <div class="list_status">{{item.status_str}}</div>
        </div>
        <div class="list_center">
          <div class="list_money">
            <div class="money">{{item.real_money}}</div>
            <div class="yuan">元</div>
          </div>
          <div class="list_account">

            <div class="account_tip" v-if="item.card_no && item.withdraw_type!=3" >转让账户：{{item.card_no}}</div>
            <div v-else></div>
            <div class="account_num">查看详情</div>
          </div>
        </div>
      </div>
      <div @click="getMore()" class='whthdrew_label more' v-if="datalengthX">查看更多</div>
      <!-- 暂无信息  开始 -->
      <div class="page_none" v-if="!withdrawList.length">
        <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
      </div>
      <!-- 暂无信息  结束 -->
    </div>
  </div>
</template>
<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http';

  export default {
    data() {
      return {
        withdrawList: [], // 接口获取列表
        datalengthX: false, //判断是否要继续请求订单列,默认值false
        pages: 1 //判断是否要继续请求订单的第几页数,默认值1
      }
    },
    created() {
      this.request("getWithdrawList", {
        page: 1,
        page_size: 20
      })
    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      tapindex() {
        this.$router.push({
          path: '/'
        })
      },
      detailtap(e) {
        //跳转到转让详情
        let order_no = this.withdrawList[e].id
        this.$router.push({
          name: 'withdrawDetail',
          query: {
            id: order_no
          }
        })
      },
      //查看更多
      getMore() {
        let that = this
        if (!that.datalengthX) {
          this.$toast({
            message: '没有更多了',
          });
          return
        }
        let page = (that.pages) + 1
        // that.changeNavIndex(that.navIndex, page, false)
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取订单信息列表
          case 'getWithdrawList':
            httper.post('user/withdraw-list', requestData, res => {
              console.log('reslist', res)
              let lengthX = res.data.length - 20 === 0 //判断列是否20条
              that.withdrawList = [...that.withdrawList, ...res.data]
              that.datalengthX = lengthX
              console.log("withdrawList", that.withdrawList)
            }, true)
            break
        }
      },
    }
  }
</script>
<style scoped>
  .withdraw_list {
    width: 100%;
    height: 100%;
    background-color: rgb(247, 245, 245);
  }

  .list_detail {
    margin: 10px 15px 0 15px;
    padding: 10px 15px;
    height: 143px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
  }

  .list_top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    border-bottom: 1px solid #dedede;
  }

  .list_time {
    font-size: 14px;
    color: rgb(156, 156, 156);
  }

  .list_status {
    font-size: 14px;
    /* font-weight: bold; */
    color: rgb(20, 20, 20)
  }

  .list_center {
    display: flex;
    flex-direction: column;
  }

  .list_money {
    display: flex;
    align-items: center;
    padding: 5px 0;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .money {
    font-size: 31px;
    /* font-weight: bold; */
    color: rgb(20, 20, 20)
  }

  .yuan {
    font-size: 12px;
    padding-top: 13px;
    margin-left: 5px;
  }

  .list_account {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .account_tip {
    font-size: 12px;
    font-weight: 400;
    color: rgba(54, 54, 54, 1);
  }

  .account_num {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
  }

  .list_bottom {
    border-top: 1px rgb(197, 197, 197) solid;
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
  }

  .detail_tip {
    font-size: 14px;
  }

  /* nothing */
  .nothing {
    width: 100%;
    margin-top: 100px;
    text-align: center;
  }

  .nothing_panel {
    width: 50px;
    height: 50px;
    margin: 0 auto;
  }

  .nothing_img {
    width: 100%;
    height: 100%;
  }

  .nothing_text {
    font-size: 15px;
    color: #999;
    margin: 5px 0;
  }

  .nothing_btn {
    width: 50px;
    margin: 0 auto;
    border: 1px solid #cecece;
    padding: 3px;
    background-color: #fff;
    font-size: 14px;
  }

  .whthdrew_label {
    margin: 20px 15px 0;
    display: block;
    text-align: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .more {
    padding: 10px 0;
    text-align: center;
    font-size: 15px;
    border: 1px solid #E3E3E3;
    box-shadow: 0 3px 3px #E3E3E3;
    color: orange;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/withdrawList.vue